import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContextResolution } from '../contexts/ContextResolutionContext.js';

/**
 * Context Resolution Guard
 * 根據 Context Resolution 狀態決定是否顯示 UnboundLanding 或正常應用程式
 */
export function ContextResolutionGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isReady, status } = useContextResolution();
  const navigate = useNavigate();

  useEffect(() => {
    // 等待 Context Resolution 完成
    if (!isReady) {
      return;
    }

    // 如果狀態是 unbound，導向 /unbound 路由
    // 但排除 Lite 路由（/lite/*），因為 Lite 有自己的註冊流程
    if (status === 'unbound') {
      const currentPath = window.location.pathname;
      // 檢查當前路徑，避免無限重定向
      // 排除 Lite 路由和註冊頁面（/lite/* 已經涵蓋了 /lite/register）
      const isLiteRoute = currentPath.startsWith('/lite');
      const isRegisterRoute = currentPath === '/register';

      if (currentPath !== '/unbound' && !isLiteRoute && !isRegisterRoute) {
        navigate('/unbound', { replace: true });
      }
    }
  }, [isReady, status, navigate]);

  // 如果狀態是 unbound，且不在 Lite 路由上，不渲染子組件（會顯示 UnboundLanding）
  const currentPath =
    typeof window !== 'undefined' ? window.location.pathname : '';
  const isLiteRoute = currentPath.startsWith('/lite');
  const isRegisterRoute = currentPath === '/register';

  if (status === 'unbound' && !isLiteRoute && !isRegisterRoute) {
    return null;
  }

  // 其他狀態（bound, loading, error, not_in_group）正常渲染子組件
  return <>{children}</>;
}
